module.exports = __webpack_public_path__ + "img/layout-4.21757e03.png";